export default "__VITE_ASSET__DRy4kFkk__"